import React, { useEffect, useState } from "react";
import { Container, Typography, Select, MenuItem, Button, Card, CardContent, Divider, Grid, TextField } from "@mui/material";
import "./RechargePortal.css";
import { fetchSpecialConfig } from "../global/commonNetworkController";
import useAuth from "../../hooks/useAuth";
import { AADHAR_REQUEST_COUNT, SMS_REQUEST_COUNT } from "../../constants/ConfigConstant";
import { BACKEND_BASE_URL, isEmpty, isNumberEmpty, SUCCESS } from "../../constants/Constants";
import axios from "axios";
import CommonUtils from "../../utilities/CommonUtils";
import { DisplayRazorpay } from "../global/razorpayApi";
import Loader from "../../global/loader/Loader";


const RechargePortal = () => {

    const { authUser, activeShopHash, updateConfiguration, showConfirmDialog } = useAuth();

    //SMS
    const [selectedCount, setSelectedCount] = useState("");
    const [selectedPrice, setSelectedPrice] = useState("");
    const [smsPackDetails, setSmsPackDetails] = useState({})

    //Aadhar
    const [aadharReqCount, setAadharReqCount] = useState("");
    const [aadharReqPrice, setAadharReqPrice] = useState("");
    const [aadharPackDetails, setAadharPackDetails] = useState({})

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getConfigDetails(SMS_REQUEST_COUNT);
        getConfigDetails(AADHAR_REQUEST_COUNT);
    }, []);

    const getConfigDetails = async (pConfigName) => {
        await fetchSpecialConfig({
            authUser: authUser,
            activeShopHash: activeShopHash,
            configName: pConfigName,
            onResponseCallback: (configName, value) => {
                if (configName === SMS_REQUEST_COUNT) {
                    if (value) {
                        setSmsPackDetails(value);
                    }
                } else if (configName === AADHAR_REQUEST_COUNT) {
                    if (value) {
                        setAadharPackDetails(value);
                    }
                }
            }
        })
    }


    const handleSmsChange = (event) => {
        const value = event.target.value;
        setSelectedCount(value);
        setSelectedPrice(smsPackDetails?.admin_pack[value] ?? 0);
    };

    const handleAadharChange = (event) => {
        const value = event.target.value;
        if (!isNumberEmpty(value)) {
            const parseVal = Number(value);
            const parsePerPrice = Number(aadharPackDetails?.admin_pack);

            const price = parseVal * parsePerPrice;
            setAadharReqCount(parseVal);
            setAadharReqPrice(price);
        } else {
            setAadharReqCount("");
            setAadharReqPrice("");
        }
    };

    const handleSmsPay = async () => {
        try {
            setLoader(true);
            const response = await axios.get(`${BACKEND_BASE_URL}recharge-sms-pack`, {
                params: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    smsCount: selectedCount,
                    price: selectedPrice,
                },
            });
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.payLoad;
                const pgId = CommonUtils.decode(payLoad.keyId);
                DisplayRazorpay(authUser, pgId,
                    payLoad.amountInPaisa,
                    payLoad.orderId, payLoad.currency, "Spark N Pass Nxt Gen Pvt Ltd", "SMS Subscription Service", "", showConfirmDialog,
                    () => {
                        fetchSpecialConfig(SMS_REQUEST_COUNT);
                        updateConfiguration(SMS_REQUEST_COUNT, true);
                    }
                )
            }
        } catch (err) {
            console.error("getProfile", err);
        } finally {
            setLoader(false);
        }
    }

    const handleAadharPay = async () => {
        try {
            setLoader(true);
            const response = await axios.get(`${BACKEND_BASE_URL}recharge-aadhar-pack`, {
                params: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    count: aadharReqCount,
                },
            });
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.payLoad;
                const pgId = CommonUtils.decode(payLoad.keyId);
                DisplayRazorpay(authUser, pgId,
                    payLoad.amountInPaisa,
                    payLoad.orderId, payLoad.currency, "Spark N Pass Nxt Gen Pvt Ltd", "Aadhaar Verification Service", "", showConfirmDialog,
                    () => {
                        fetchSpecialConfig(AADHAR_REQUEST_COUNT);
                        updateConfiguration(AADHAR_REQUEST_COUNT, true);
                    }
                )
            }
        } catch (err) {
            console.error("getProfile", err);
        } finally {
            setLoader(false);
        }
    }


    const renderSmsCard = () => {
        return (
            <Container className="sms-container">
                <Card className="sms-card">
                    <CardContent className="sms-content">
                        <Typography variant="h4" className="main-header">
                            SMS Subscription Service
                        </Typography>

                        <Divider className="divider" />

                        <Typography variant="subtitle1" className="info-text">
                            {smsPackDetails?.countStr ?? ""}
                        </Typography>

                        <Typography variant="subtitle1" className="info-text">
                            Registered Pack: {!isEmpty(smsPackDetails?.registered_pack) ? smsPackDetails?.registered_pack : "No Pack"}
                        </Typography>

                        <div className="select-container">
                            <Typography variant="subtitle1" className="label">
                                Choose SMS Pack:
                            </Typography>
                            <Select
                                fullWidth
                                value={selectedCount}
                                onChange={handleSmsChange}
                                displayEmpty
                                className="select-box"
                            >
                                <MenuItem value="" disabled>
                                    Select Pack
                                </MenuItem>
                                {Object.keys(smsPackDetails?.admin_pack ?? []).map((key) => (
                                    <MenuItem key={key} value={key}>
                                        {`${key} SMS / ₹${smsPackDetails?.admin_pack[key]}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>

                        {selectedPrice && (
                            <div className="checkout-container">
                                <Button variant="contained" className="checkout-btn" onPointerDown={() => handleSmsPay()}>
                                    Checkout ₹{selectedPrice}
                                </Button>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </Container>
        )
    }

    const renderAadharService = () => {
        return (
            <Container className="sms-container">
                <Card className="sms-card">
                    <CardContent className="sms-content">
                        <Typography variant="h4" className="main-header">
                            Aadhaar Verification Service
                        </Typography>

                        <Divider className="divider" />

                        <Typography variant="subtitle1" className="info-text">
                            {aadharPackDetails?.countStr ?? ""}
                        </Typography>

                        <Typography variant="subtitle1" className="info-text">
                            Registered Pack: {!isEmpty(aadharPackDetails?.registered_pack) ? aadharPackDetails?.registered_pack : "No Pack"}
                        </Typography>

                        <div className="select-container">
                            <TextField
                                label="Per transaction count "
                                type="number"
                                value={aadharReqCount}
                                onChange={(e) =>
                                    handleAadharChange(e)
                                }
                                fullWidth

                            />
                        </div>

                        {aadharReqPrice && (
                            <div className="checkout-container">
                                <Button variant="contained" className="checkout-btn" onPointerDown={() => handleAadharPay()}>
                                    Checkout ₹{aadharReqPrice}
                                </Button>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </Container>
        )
    }

    return (
        <Grid container spacing={1}>
            {loader && <Loader />}
            <Grid item xs={12} md={6} sm={6}>
                {renderSmsCard()}
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
                {renderAadharService()}
            </Grid>
        </Grid>
    )
};

export { RechargePortal };